import React, { useEffect, useState } from "react";
import "./BadgePrintCard.css";
import { useLocation, useNavigate } from "react-router-dom";
import QRCode from "qrcode";

const BadgePrintCard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, company_name, qrUrl } = location.state || {};
  const [qrImage, setQrImage] = useState("");

  useEffect(() => {
    if (qrUrl) {
      QRCode.toDataURL(qrUrl, { errorCorrectionLevel: "H" })
        .then((url) => setQrImage(url))
        .catch((err) => console.error("QR Generation Error:", err));
    }
  }, [qrUrl]);

  const handlePrint = () => {
    window.print();
  };

  // Dynamic styles for long names
  const dynamicNameStyle = {
    fontSize: name?.length > 24 ? "2.3vw" : "3.3vw",
  };

  const dynamicCompanyStyle = {
    fontSize: company_name?.length > 24 ? "2.1vw" : "3vw",
  };
  // ✅ Function to insert line break after 35 chars
  const formatCompanyName = (text) => {
    if (!text) return "";
    if (text.length <= 43) return text;

    // Find the last space before or at 35 chars
    let breakIndex = text.lastIndexOf(" ", 43);

    // If no space found (single long word), break exactly at 35
    if (breakIndex === -1) breakIndex = 43;

    return (
      <>
        {text.substring(0, breakIndex)}
        <br />
        {text.substring(breakIndex + 1)}
      </>
    );
  };

  return (
    <div className="print-area-wrapper">
      <div className="print-area">
        <div className="print-idcard">
          <div className="name" style={dynamicNameStyle}>
            {name}
          </div>

          {/* <div className="company" style={dynamicCompanyStyle}>
            
          </div> */}
          <div className="company" style={dynamicCompanyStyle}>
            {formatCompanyName(company_name)}
          </div>

          {qrImage && <img src={qrImage} alt="QR Code" className="qr-code" />}
        </div>
      </div>

      <div className="flex items-center gap-4 mt-4 mb-4">
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-400 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-md shadow"
        >
          Back
        </button>
        <button
          onClick={handlePrint}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md shadow print-button"
        >
          Print ID Card
        </button>
      </div>
    </div>
  );
};

export default BadgePrintCard;
